import type {
	INotificationRepository,
	ICertificateRepository,
	IDashboardRepository,
	IUserProfileRepository,
	IModuleRepository,
	ITemplateRepository,
	IInvestmentProposalRepository,
	IContractRepository,
	IInvestorRepository,
	IInvestmentRepository,
	IPromoterRepository,
	IProjectRepository,
	IOrganizationRepository,
	IHubRepository,
	IPromoterProjectRepository,
	IOrgInvitationRepository,
	IOrgMemberRepository,
	IAdminDashboardRepository,
	IAdminOrganizationRepository,
	IAdminUserRepository,
	IAdminInvitationRepository,
	IAdminMembershipRepository,
	IAiAgentRepository,
	IAuthRepository,
} from "@/application/ports/repositories";

import {
	NotificationRepository,
	CertificateRepository,
	DashboardRepository,
	UserProfileRepository,
	ModuleRepository,
	TemplateRepository,
	InvestmentProposalRepository,
	ContractRepository,
	InvestorRepository,
	InvestmentRepository,
	PromoterRepository,
	ProjectRepository,
	OrganizationRepository,
	HubRepository,
	PromoterProjectRepository,
	OrgInvitationRepository,
	OrgMemberRepository,
	AdminDashboardRepository,
	AdminOrganizationRepository,
	AdminUserRepository,
	AdminInvitationRepository,
	AdminMembershipRepository,
	AiAgentRepository,
	AuthRepository,
} from "@/infrastructure/api/repositories";

// Lazy singleton instances
let notificationRepository: INotificationRepository;
let certificateRepository: ICertificateRepository;
let dashboardRepository: IDashboardRepository;
let userProfileRepository: IUserProfileRepository;
let moduleRepository: IModuleRepository;
let templateRepository: ITemplateRepository;
let investmentProposalRepository: IInvestmentProposalRepository;
let contractRepository: IContractRepository;
let investorRepository: IInvestorRepository;
let investmentRepository: IInvestmentRepository;
let promoterRepository: IPromoterRepository;
let projectRepository: IProjectRepository;
let organizationRepository: IOrganizationRepository;
let hubRepository: IHubRepository;
let promoterProjectRepository: IPromoterProjectRepository;
let orgInvitationRepository: IOrgInvitationRepository;
let orgMemberRepository: IOrgMemberRepository;
let adminDashboardRepository: IAdminDashboardRepository;
let adminOrganizationRepository: IAdminOrganizationRepository;
let adminUserRepository: IAdminUserRepository;
let adminInvitationRepository: IAdminInvitationRepository;
let adminMembershipRepository: IAdminMembershipRepository;
let aiAgentRepository: IAiAgentRepository;
let authRepository: IAuthRepository;

export function getNotificationRepository(): INotificationRepository {
	if (!notificationRepository)
		notificationRepository = new NotificationRepository();
	return notificationRepository;
}

export function getCertificateRepository(): ICertificateRepository {
	if (!certificateRepository)
		certificateRepository = new CertificateRepository();
	return certificateRepository;
}

export function getDashboardRepository(): IDashboardRepository {
	if (!dashboardRepository) dashboardRepository = new DashboardRepository();
	return dashboardRepository;
}

export function getUserProfileRepository(): IUserProfileRepository {
	if (!userProfileRepository)
		userProfileRepository = new UserProfileRepository();
	return userProfileRepository;
}

export function getModuleRepository(): IModuleRepository {
	if (!moduleRepository) moduleRepository = new ModuleRepository();
	return moduleRepository;
}

export function getTemplateRepository(): ITemplateRepository {
	if (!templateRepository) templateRepository = new TemplateRepository();
	return templateRepository;
}

export function getInvestmentProposalRepository(): IInvestmentProposalRepository {
	if (!investmentProposalRepository)
		investmentProposalRepository = new InvestmentProposalRepository();
	return investmentProposalRepository;
}

export function getContractRepository(): IContractRepository {
	if (!contractRepository) contractRepository = new ContractRepository();
	return contractRepository;
}

export function getInvestorRepository(): IInvestorRepository {
	if (!investorRepository) investorRepository = new InvestorRepository();
	return investorRepository;
}

export function getInvestmentRepository(): IInvestmentRepository {
	if (!investmentRepository) investmentRepository = new InvestmentRepository();
	return investmentRepository;
}

export function getPromoterRepository(): IPromoterRepository {
	if (!promoterRepository) promoterRepository = new PromoterRepository();
	return promoterRepository;
}

export function getProjectRepository(): IProjectRepository {
	if (!projectRepository) projectRepository = new ProjectRepository();
	return projectRepository;
}

export function getOrganizationRepository(): IOrganizationRepository {
	if (!organizationRepository)
		organizationRepository = new OrganizationRepository();
	return organizationRepository;
}

export function getHubRepository(): IHubRepository {
	if (!hubRepository) hubRepository = new HubRepository();
	return hubRepository;
}

export function getPromoterProjectRepository(): IPromoterProjectRepository {
	if (!promoterProjectRepository)
		promoterProjectRepository = new PromoterProjectRepository();
	return promoterProjectRepository;
}

export function getOrgInvitationRepository(): IOrgInvitationRepository {
	if (!orgInvitationRepository)
		orgInvitationRepository = new OrgInvitationRepository();
	return orgInvitationRepository;
}

export function getOrgMemberRepository(): IOrgMemberRepository {
	if (!orgMemberRepository) orgMemberRepository = new OrgMemberRepository();
	return orgMemberRepository;
}

export function getAdminDashboardRepository(): IAdminDashboardRepository {
	if (!adminDashboardRepository)
		adminDashboardRepository = new AdminDashboardRepository();
	return adminDashboardRepository;
}

export function getAdminOrganizationRepository(): IAdminOrganizationRepository {
	if (!adminOrganizationRepository)
		adminOrganizationRepository = new AdminOrganizationRepository();
	return adminOrganizationRepository;
}

export function getAdminUserRepository(): IAdminUserRepository {
	if (!adminUserRepository) adminUserRepository = new AdminUserRepository();
	return adminUserRepository;
}

export function getAdminInvitationRepository(): IAdminInvitationRepository {
	if (!adminInvitationRepository)
		adminInvitationRepository = new AdminInvitationRepository();
	return adminInvitationRepository;
}

export function getAdminMembershipRepository(): IAdminMembershipRepository {
	if (!adminMembershipRepository)
		adminMembershipRepository = new AdminMembershipRepository();
	return adminMembershipRepository;
}

export function getAiAgentRepository(): IAiAgentRepository {
	if (!aiAgentRepository) aiAgentRepository = new AiAgentRepository();
	return aiAgentRepository;
}

export function getAuthRepository(): IAuthRepository {
	if (!authRepository) authRepository = new AuthRepository();
	return authRepository;
}
